export class Scheduling {
    date: string;
    period: number;
}



// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/app/shared/models/payment/scheduling.ts